import { render } from "./CraftConfig.vue?vue&type=template&id=6afd2721&scoped=true"
import script from "./CraftConfig.vue?vue&type=script&lang=js"
export * from "./CraftConfig.vue?vue&type=script&lang=js"

import "./CraftConfig.vue?vue&type=style&index=0&id=6afd2721&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afd2721"]])

export default __exports__